import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface UnsavedChangesDialogProps {
  /** Whether the confirmation is showing. */
  open: boolean;
  /** AlertDialog open/close handler (Escape, click-outside, and "Keep editing" close it). */
  onOpenChange: (open: boolean) => void;
  /** "Discard changes" action — abandon the in-progress edits and close the parent dialog. */
  onDiscard: () => void;
}

/**
 * Shared confirmation shown when a user tries to leave a create/edit form that
 * has unsaved input. Driven by {@link useUnsavedChangesGuard}. "Keep editing" is
 * the safe default; "Discard changes" is destructive.
 */
export function UnsavedChangesDialog({ open, onOpenChange, onDiscard }: UnsavedChangesDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Discard unsaved changes?</AlertDialogTitle>
          <AlertDialogDescription>
            You've started filling this out but haven't saved yet. If you leave now, what you've
            entered will be lost.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep editing</AlertDialogCancel>
          <AlertDialogAction
            onClick={onDiscard}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90">
            Discard changes
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
